import * as Common from '@/tenantCatalog/common';

export class Billing extends Common.ObjectBase{
  constructor(){
    super('Billing');
    this.binders.tenant = new Common.ModelBinder(Common.Tenant);
  }
  public tenantId :string = '';
  public tenant : Common.Tenant;
  public closingDate : Date;
  public amount : number;
  public taxAmount : number;
  public totalAmount: number;
  public paidAmount: number;
  public get balanceAmount() {return this.totalAmount - this.paidAmount} ;
  public result :string;
  public status : billingFlags;
}
export enum billingFlags {billed, paid}
export class BillingQuery extends Common.LoadQuery {
  constructor(){
    super('BillingQuery',Billing);
    this.sort = 'tenantId';    
  }
  public tenantId :string = '';
  public tenantName: string = '';
  public closingDate : Date = null;  
  public status : number = null;  
  public partnerId:string = '';
}